import moment from 'moment';
import writeXlsxFile from 'write-excel-file';

const styleHeader: any = {
    backgroundColor: '#eeeeee',
    height: 18,
    alignVertical: 'center',
};

type HeaderTypes = {
    name: string;
    date?: string;
};

interface PlanogramListExport {
    product_name: string;
    standard_amount: number;
    stock_amount: number;
    bar_code: string;
    amount_to_transfer: number;
}

interface TableTypes extends HeaderTypes {
    products: PlanogramListExport[];
    name: string;
}

const row2 = (date: string) => [
    {
        value: 'Data:',
        ...styleHeader,
        align: 'left',
        topBorderColor: '#727272',
        leftBorderColor: '#727272',
    },
    {
        value: `${moment(new Date(date)).format('DD/MM/YYYY - HH:mm')}`,
        span: null,
        height: 18,
        alignVertical: 'center',
        align: 'left',
        fontWeight: 'bold',
    },
    {},
    {},
    {},
];

const row8 = (name: string) => [
    {
        value: 'Lojas:',
        ...styleHeader,
        align: 'left',
        span: null,
        topBorderColor: '#727272',
        leftBorderColor: '#727272',
    },
    {
        value: name.toUpperCase(),
        span: 4,
        height: 18,
        alignVertical: 'center',
        align: 'left',
        topBorderColor: '#727272',
        fontWeight: 'bold',
    },
];

const row3 = (stock_origin: string) => [
    {
        value: 'Estoque de Origem:',
        ...styleHeader,
        align: 'left',
        span: null,
        topBorderColor: '#727272',
        leftBorderColor: '#727272',
    },
    {},
    {
        value: stock_origin,
        span: null,
        height: 18,
        alignVertical: 'center',
        align: 'right',
        topBorderColor: '#727272',
        fontWeight: 'bold',
    },
    {},
    {},
];

const row4 = (stock_destination: string) => [
    {
        value: 'Estoque de Destino:',
        ...styleHeader,
        align: 'left',
        span: null,
        topBorderColor: '#727272',
        leftBorderColor: '#727272',
    },
    {},
    {
        value: stock_destination,
        span: null,
        height: 18,
        alignVertical: 'center',
        align: 'right',
        topBorderColor: '#727272',
        fontWeight: 'bold',
    },
    {},
    {},
];

const row5 = (user_performed: string) => [
    {
        value: 'Executado por:',
        ...styleHeader,
        align: 'left',
        span: null,
        topBorderColor: '#727272',
        leftBorderColor: '#727272',
    },
    {},
    {
        value: user_performed,
        span: null,
        height: 18,
        alignVertical: 'center',
        align: 'right',
        topBorderColor: '#727272',
        fontWeight: 'bold',
    },
    {},
    {},
];

const row6 = (user_create: string) => [
    {
        value: 'Criado por:',
        ...styleHeader,
        align: 'left',
        span: null,
        topBorderColor: '#727272',
        leftBorderColor: '#727272',
        bottomBorderColor: '#727272',
    },
    {},
    {
        value: user_create,
        span: null,
        height: 18,
        alignVertical: 'center',
        align: 'right',
        topBorderColor: '#727272',
        fontWeight: 'bold',
    },
    {},
    {},
];
const row7 = [
    {
        value: 'Nome do Produto',
        fontWeight: 'bold',
        borderColor: '#727272',
        align: 'center',
        ...styleHeader,
        width: 35,
    },
    {
        value: 'Código de barras Primário',
        fontWeight: 'bold',
        wrap: true,
        borderColor: '#727272',
        align: 'center',
        ...styleHeader,
    },
    {
        value: 'Qtd. Padrão Destino',
        fontWeight: 'bold',
        wrap: true,
        borderColor: '#727272',
        align: 'center',
        ...styleHeader,
    },
    {
        value: 'Qtd. Estoque Destino',
        fontWeight: 'bold',
        wrap: true,
        borderColor: '#727272',
        align: 'center',
        ...styleHeader,
    },
    {
        value: 'Qtd. à Transferir',
        fontWeight: 'bold',
        borderColor: '#727272',
        wrap: true,
        align: 'center',
        ...styleHeader,
    },
];

const header = ({
    date = new Date().toString(),
    name = '',
}: HeaderTypes): any => [
    row2(date),
    row8(name),
    row3(''),
    row4(''),
    row5(''),
    row6(''),
    row7,
];

export const exportPlanogramList = ({ products, name }: TableTypes): void => {
    const columns = [
        { width: 40 },
        { width: 40 },
        { width: 30 },
        { width: 20 },
        { width: 25 },
    ];
    const cellStyle = {
        borderColor: '#727272',
        height: 15,
        align: 'center',
    };

    const productsFormatteds = products.map((product) => [
        { value: String(product.product_name), ...cellStyle },
        { value: String(product.bar_code || 'Não informado'), ...cellStyle },
        { value: product.standard_amount, type: Number, ...cellStyle },
        { value: product.stock_amount, type: Number, ...cellStyle },
        { value: product.amount_to_transfer, type: Number, ...cellStyle },
    ]);

    writeXlsxFile(
        [
            ...header({
                name,
            }),
            ...productsFormatteds,
        ],
        {
            columns,
            fontSize: 10,
            fileName: `planogram_${new Date().toLocaleDateString(
                'pt-BR',
            )}.xlsx`,
        },
    );
};
